import React from 'react'
import { Button, ButtonGroup, UncontrolledTooltip } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';

const ReportButtons = ({downloadDoc, downloadCSV, downloadXlsx, color = 'raporty', disabled=false}) => {
    const notify = () => toast.info(
        "Pobrane dane są w formacie tekstowym, musisz dokonać konwersji na format liczbowy - więcej informacji w przewodniku.",
        { position: "bottom-right" }
    );
    return (
        <div style={{textAlign:"right"}}>
            <ToastContainer />
            <ButtonGroup id='downloadButtons'>
                <Button className="btn-round" color={color} outline type="button" size="sm" onClick={()=>{downloadDoc()}} disabled={disabled}>
                .doc
                </Button>
                <Button className="btn-round" color={color} outline type="button" size="sm" onClick={()=>{downloadCSV()}}>
                .csv
                </Button>
                <Button className="btn-round" color={color} outline type="button" size="sm" onClick={()=>{downloadXlsx();notify()}}>
                .xlsx
                </Button>
            </ButtonGroup>
            <UncontrolledTooltip delay={0} placement="top" target='downloadButtons'>
                Pobierz tabelę
            </UncontrolledTooltip>
        </div>
    )
}
export default ReportButtons
